(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-red-sole-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mm-shoe').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    const selected = [];
    const initial = variants.find((variant) => variant.id == root.querySelector('[data-variant-id]').value) || variants[0];
    initial.options.forEach((value, index) => selected[index] = value);
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    const variantFor = (options) => variants.find((variant) => variant.options.every((value, index) => value === options[index]));
    const update = () => {
      const variant = variantFor(selected);
      if (!variant) return;
      root.querySelector('[data-variant-id]').value = variant.id;
      root.querySelector('[data-dynamic-id]').value = variant.id;
      root.querySelector('[data-price]').textContent = money(variant.price);
      root.querySelector('[data-single-price]').textContent = money(variant.price);
      root.querySelector('[data-double-price]').textContent = money(Math.round(variant.price * 2 * .8));
      root.querySelector('[data-color-label]').textContent = selected[0];
      root.querySelector('[data-sticky-selection]').textContent = selected.join(' / ');
      root.querySelector('[data-sticky-price]').textContent = money(variant.price);
      root.querySelectorAll('[data-option-index]').forEach((button) => {
        const active = selected[Number(button.dataset.optionIndex)] === button.dataset.optionValue;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
      });
      if (variant.featured_media) {
        const target = root.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
        if (target && window.innerWidth < 990) {
          root.querySelectorAll('.mm-shoe__media').forEach((media) => media.classList.remove('is-active'));
          target.classList.add('is-active');
        }
      }
    };
    root.querySelectorAll('[data-option-index]').forEach((button) => button.addEventListener('click', () => {
      selected[Number(button.dataset.optionIndex)] = button.dataset.optionValue;
      update();
    }));
    root.querySelectorAll('[data-media-target]').forEach((button) => button.addEventListener('click', () => {
      root.querySelectorAll('[data-media-target]').forEach((thumb) => thumb.classList.remove('is-active'));
      button.classList.add('is-active');
      const media = root.querySelector(`[data-media-id="${button.dataset.mediaTarget}"]`);
      if (window.innerWidth < 990) {
        root.querySelectorAll('.mm-shoe__media').forEach((item) => item.classList.remove('is-active'));
        media.classList.add('is-active');
      } else media.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }));
    root.querySelectorAll('.mm-shoe__pack').forEach((pack) => pack.addEventListener('click', () => {
      root.querySelectorAll('.mm-shoe__pack').forEach((item) => item.classList.remove('is-selected'));
      pack.classList.add('is-selected');
      const count = Number(pack.querySelector('input').value);
      root.querySelector('.mm-shoe__second').hidden = count !== 2;
      root.querySelector('.mm-shoe__dynamic-form').hidden = count === 2;
      root.querySelector('[data-add-label]').textContent = count === 2 ? 'Añadir los 2 pares al carrito' : 'Añadir al carrito';
    }));
    const add = async () => {
      const form = root.querySelector('[data-product-form]');
      const button = root.querySelector('.mm-shoe__add');
      const error = root.querySelector('[data-error]');
      const first = variantFor(selected);
      const pack = Number(root.querySelector('input[name^="pack-"]:checked').value);
      const items = [{ id: Number(first.id), quantity: 1, properties: { Paquete: pack === 2 ? '2 pares · demostración' : '1 par' } }];
      if (pack === 2) {
        const secondOptions = selected.slice();
        secondOptions[0] = root.querySelector('[data-second-color]').value;
        secondOptions[1] = root.querySelector('[data-second-size]').value;
        const second = variantFor(secondOptions);
        if (!second) throw new Error('La combinación del segundo par no está disponible.');
        items.push({ id: Number(second.id), quantity: 1, properties: { Paquete: '2 pares · demostración' } });
      }
      button.disabled = true;
      error.hidden = true;
      try {
        const cartUi = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = { items };
        if (cartUi && cartUi.getSectionsToRender) {
          body.sections = cartUi.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          if (cartUi.setActiveElement) cartUi.setActiveElement(document.activeElement);
        }
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'No se pudo añadir al carrito.');
        if (cartUi && cartUi.renderContents) cartUi.renderContents(result);
        else window.location.href = window.routes?.cart_url || '/cart';
      } catch (reason) {
        error.textContent = reason.message;
        error.hidden = false;
      } finally { button.disabled = false; }
    };
    root.querySelector('[data-product-form]').addEventListener('submit', (event) => { event.preventDefault(); add(); });
    root.querySelector('[data-sticky-add]').addEventListener('click', () => root.querySelector('[data-product-form]').requestSubmit());
    const sticky = root.querySelector('[data-sticky]');
    new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: .1 }).observe(root.querySelector('.mm-shoe__form'));
    const dialog = root.querySelector('[data-size-dialog]');
    root.querySelector('[data-open-size]').addEventListener('click', () => dialog.showModal());
    root.querySelector('[data-close-size]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    update();
  });

  } catch(e) { console.error(e); }
})();
})();
